import {z} from 'zod';
import {Date} from './date';

export const DelayOfPayment = z.object({
  oldInstallmentAmount: z.number(),
  newInstallmentAmount: z.number(),
  newInstallmentDate: Date.nullable(),
  interest: z.number(),
  oldBalloonAmount: z.number().nullable(),
  newBalloonAmount: z.number().nullable(),
  balloonDate: Date.nullable(),
  oldTerm: Date.nullable(),
  newTerm: Date.nullable(),
  balloonInTwenty: z.boolean(),
});

export type DelayOfPayment = z.infer<typeof DelayOfPayment>;
